import customHeaders, { getSpace } from '../../../common/headers'
import { RavshanHttps } from '../../../fetchUrls'
import { useEffect, useState } from 'react'
import { InputDinamycPlaceholder, ButtonBasic, Tabs, Checkbox, InputSearch } from "@lk-gtcom/ecomlab-components"
import useGeneralStore from '../../../store/general'
import { CardExecutor } from '../../CardsComponents/CardExecutor/CardExecutor'
import { TabsGreen } from '../../TabsGreen/TabsGreen'
import { SettingsRow } from './SettingsRow/SettingsRow'
import { ModalAddAccountWebmaster } from './ModalAddAccountWebmaster/ModalAddAccountWebmaster'
import dayjs from 'dayjs'
import './ModalAddNewWiki.scss'
import { ButtonWithIcon } from '../../Buttons/ButtonWithIcon/ButtonWithIcon'
import { usePushNotifications } from '../../../common/pushNotification'
import { ModalComponent } from '../ModalComponent/ModalComponent'
import { useResponseHandler } from '../../../common/auth'

const btn_tab = [
    { label: 'Доступные к добавлению', value: 'available' },
    { label: 'Добавленные', value: 'added' }
];

const btns_tab = [
    { label: 'Участники', value: 'exexutors' },
    { label: 'Настройки для seo', value: 'seo' }
];

const ModalAddNewWiki = ({ ...props }) => {
    const {
        fetchWikiList,
        currentWiki,
        setCurrentWiki,
        setIsModal,
        onDeleteHandler,
        id,
        setId
    } = props
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [name, setName] = useState(currentWiki?.name ? currentWiki?.name : '')
    const [urlWebsite, setUrlWebsite] = useState(currentWiki?.base_url ? currentWiki?.base_url : '')
    const [webmasterId, setWebmasterId] = useState(currentWiki?.webmaster?.id ? currentWiki?.webmaster : null)
    const [createdAt, setCreatedAt] = useState(currentWiki?.created_at ? (dayjs(currentWiki?.created_at).format('DD.MM.YYYY')) : '')
    const [executorAvailable, setExecutorAvailable] = useState([]);
    const [executorAdded, setExecutorAdded] = useState([]);
    const [pageValue, setPageValue] = useState(btn_tab[0]?.value)
    const [status, setStatus] = useState(btns_tab?.[0]?.value)
    const [loading, setLoading] = useState(true)

    const [searchAccount, setSearchAccount] = useState('')
    const [isModalAdd, setIsModalAdd] = useState(false)
    const [isFavorite, setIsFavorite] = useState(currentWiki?.is_favorite ? currentWiki?.is_favorite : false);
    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    const btns = [{
        btn: 'Удалить', func: () => {
            onDeleteHandler(id)
            setId(null)
            setCurrentWiki(null)
            setIsModal(false)
        }
    }];

    // Создать вики
    const createWiki = () => {
        const url = `${RavshanHttps}/api/v2/article/wiki/${currentWiki ? 'change' : 'create'}`

        const wiki_id = currentWiki ? { wiki_id: currentWiki?.id } : {}

        const body = JSON.stringify({
            name,
            ...wiki_id
        })

        fetch(url, { body, method: currentWiki ? 'PUT' : 'POST', headers })
            .then(res => {
                if (res.status === 409) {
                    addErrorPush('Лимиты по тарифу исчерпаны')
                    setCurrentWiki(null)
                    setIsModal(false)
                }
                if (!res?.ok) {
                    throw new Error('bad response')
                }
                return res.json()
            })
            .then(json => {
                fetchWikiList()
                setCurrentWiki({ id: json })
            })
            .catch(handleRequestError)
    }

    // Получение участников
    const fetchGetPossibleAttendees = (status) => {
        if (!currentWiki?.id) return
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/wiki_participants?wiki_id=${currentWiki?.id}&can_be_add=${status}`;

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => {
                if (status) {
                    setExecutorAvailable(json);
                } else {
                    setExecutorAdded(json);
                }
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false))
    };

    // Добавление участников
    const fetchAddAttendees = (id) => {
        if (!id) return
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/add_participants`

        const body = JSON.stringify({
            wiki_id: currentWiki?.id,
            clients: [id]
        })

        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then(() => setTimeout(() => fetchGetPossibleAttendees(true), 100))
            .catch(handleRequestError)
    }

    // Изменение прав редактирования для участников
    const fetchChangePermission = (client, status) => {
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/change_wiki_permission`

        const body = JSON.stringify({
            wiki_id: currentWiki?.id,
            client_id: client,
            can_change: status
        })

        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then(() => setTimeout(() => fetchGetPossibleAttendees(false), 100))
            .catch(handleRequestError)
    }

    // Удаление участников
    const fetchDeleteAttendees = (id) => {
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/remove_participants`

        const body = JSON.stringify({
            wiki_id: currentWiki?.id,
            clients: [id]
        })

        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then(() => setTimeout(() => fetchGetPossibleAttendees(false), 100))
            .catch(handleRequestError)
    }

    // Изменение базового url у вики
    const fetchChangeUrl = () => {
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/wiki_url`

        const body = JSON.stringify({
            wiki_id: currentWiki?.id,
            base_url: urlWebsite || null
        })

        fetch(url, { body, method: 'PATCH', headers })
            .then(handleTableResponse)
            .then(() => addSuccessPush(`Ссылка на сайт изменена на ${urlWebsite}`))
            .catch(handleRequestError)
    }

    // Добавление в избранное
    const fetchSetIsFavorite = (status) => {
        const url = `https://portals.ecomru.ru/api/v2/article/wiki/change_wiki_favorite`

        const body = JSON.stringify({
            wiki_id: currentWiki?.id,
            is_favorite: status
        })

        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then(() => addSuccessPush(`Вики ID-${currentWiki?.id} ${status ? 'добавлен в избранное' : 'удален из избранного'}`))
            .catch(handleRequestError)
    }

    useEffect(() => {
        if (currentWiki) {
            if (pageValue == 'available') {
                fetchGetPossibleAttendees(true)
            } else {
                fetchGetPossibleAttendees(false)
            }
        }
    }, [pageValue, currentWiki]);

    const current_executors = pageValue == 'available' ? executorAvailable : executorAdded

    return (
        <>

            {isModalAdd &&
                <ModalAddAccountWebmaster
                    currentWiki={currentWiki}
                    setIsModal={setIsModalAdd}
                />}

            <ModalComponent
                loading={loading}
                isNoData={!currentWiki}
                title={currentWiki ? 'Редактировать wiki' : 'Новое wiki'}
                titleNoData={'Создайте новое WIKI для дальнейшей работы с ним'}
                descriptionNoData={<>Придумайте название для WIKI и нажмите кнопку <span style={{ color: '#22C55E', fontWeight: 600 }}>"Создать"</span></>}
                childHeader={
                    <>
                        <InputDinamycPlaceholder
                            onChange={setName}
                            textErr={'Неверное название'}
                            placeholder='Название wiki'
                            autoComplete={false}
                            changeValue={name}
                            size='s'
                            maxWidth='400px'
                        />

                        <div className='modal-add-new-wiki__header'>
                            <ButtonBasic
                                green
                                text={currentWiki ? 'Сохранить' : 'Создать'}
                                onClick={e => {
                                    fetchAddAttendees()
                                    createWiki()
                                    setCurrentWiki(null)
                                }}
                            />

                            {(currentWiki && createdAt) &&
                                <p className='modal-add-new-wiki__date-create'>{`Создано ${createdAt}`}</p>}

                            <ButtonWithIcon
                                size='m'
                                favorite
                                whiteGreen
                                style={{ marginLeft: 'auto' }}
                                changeValue={isFavorite}
                                onClick={(e) => {
                                    setIsFavorite(!isFavorite)
                                    fetchSetIsFavorite(!isFavorite)
                                }}
                            />
                        </div>
                    </>
                }
                onClose={(e) => {
                    setCurrentWiki(null)
                    setIsModal(false)
                    setCurrentWiki({ id: id })
                }}
                child={
                    <div className='modal-add-new-wiki'>
                        <TabsGreen
                            btns={btns_tab}
                            currentBtn={status}
                            setCurrentBtn={(e) => setStatus(e)}
                            checkValue={true}
                        />

                        <div className='modal-add-new-wiki__content'>
                            {
                                status === 'seo' &&
                                <>
                                    <div className='modal-add-new-wiki__row-input'>
                                        <InputDinamycPlaceholder
                                            onChange={(e) => setUrlWebsite(e)}
                                            textErr={'Неверное название'}
                                            placeholder='Название url'
                                            tooltipStatic='Введите название базового url сайта'
                                            autoComplete={false}
                                            changeValue={urlWebsite}
                                            size='s'
                                        />

                                        <ButtonBasic
                                            green
                                            text='Сохранить'
                                            onClick={fetchChangeUrl}
                                            width='fit-content'
                                        />
                                    </div>

                                    <ButtonBasic
                                        blue
                                        text="Добавить аккаунт webmaster +"
                                        onClick={(e) => setIsModalAdd(true)}
                                        width="230px"
                                    />

                                    <InputSearch
                                        placeholder="Поиск..."
                                        value={searchAccount}
                                        onChange={(e) => setSearchAccount(e)}
                                    />

                                    {webmasterId && <SettingsRow
                                        key={webmasterId?.id + webmasterId?.name}
                                        id={webmasterId?.id}
                                        name={webmasterId?.name}
                                    />}
                                </>

                            }

                            {status !== 'seo' &&
                                <>
                                    {currentWiki && <Tabs
                                        tabs={btn_tab}
                                        pageValue={pageValue}
                                        spanTab
                                        setPageValue={(e) => {
                                            setPageValue(e);
                                        }}
                                    />}

                                    <div className='modal-add-new-wiki__cards'>
                                        {current_executors?.map((props, i) => {
                                            const id = props?.id
                                            return <CardExecutor
                                                key={id + i + props.color + props?.can_change}
                                                {...props}
                                                color={props?.color}
                                                status={pageValue == 'available' ? false : true}
                                                addNewMember={(e) => {
                                                    if (pageValue == 'available') {
                                                        fetchAddAttendees(props?.id)
                                                    } else {
                                                        fetchDeleteAttendees(props?.id)
                                                    }
                                                }}
                                                btn={pageValue == 'added' &&
                                                    < Checkbox
                                                        value={props?.can_change}
                                                        onChange={(e) => fetchChangePermission(id, props?.can_change ? false : true)}>
                                                        Права на редактирование
                                                    </Checkbox>
                                                }
                                            />
                                        })}
                                    </div>
                                </>}
                        </div>
                    </div>
                }
            />
        </>
    )
}

export { ModalAddNewWiki }